import { Box, Collapse, Divider, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useState } from 'react';

const TestWebhookError = ({ open, status, response, expectation, docsLink }) => {
  const [expanded, setExpanded] = useState(false);

  if (!open) return null;

  return (
    <Box
      sx={{
        mt: 1.5,
        borderRadius: 2,
        border: '1px solid #374151',
        background: '#1e1e1e',
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 1.5,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant="body2" sx={{ color: '#9ca3af', fontWeight: 500 }}>
          {expanded ? 'Hide details' : 'Show details'}
        </Typography>

        <IconButton size="small" sx={{ color: '#9ca3af' }}>
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={expanded}>
        <Box sx={{ px: 2, pb: 2 }}>
          <Divider sx={{ borderColor: '#1f2937', mb: 2 }} />

          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Typography
              sx={{
                width: 90,
                fontSize: 12,
                color: '#9ca3af',
                letterSpacing: 1,
              }}
            >
              STATUS
            </Typography>

            <Box
              sx={{
                px: 1.5,
                py: 0.3,
                borderRadius: 1,
                fontSize: 13,
                fontWeight: 600,
                background: '#2a1a1a',
                color: '#f87171',
                border: '1px solid #7f1d1d',
              }}
            >
              {status || '-'}
            </Box>
          </Box>

          <Box
            sx={{
              mb: 2,
              p: 1.5,
              borderRadius: 1.5,
              border: '1px solid #374151',
              background: '#1e1e1e',
            }}
          >
            <Typography
              sx={{
                fontSize: 11,
                color: '#9ca3af',
                letterSpacing: 1,
                mb: 0.5,
              }}
            >
              EXPECTATION
            </Typography>

            <Typography
              sx={{
                fontSize: 13,
                color: '#e5e7eb',
                lineHeight: 1.5,
              }}
            >
              {expectation}
            </Typography>

            {docsLink && (
              <Typography
                component="a"
                href={docsLink}
                target="_blank"
                rel="noopener"
                sx={{
                  display: 'inline-block',
                  mt: 1,
                  fontSize: 12,
                  color: '#60a5fa',
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                Learn how to generate HMAC signatures
              </Typography>
            )}
          </Box>

          <Typography
            sx={{
              fontSize: 11,
              color: '#9ca3af',
              letterSpacing: 1,
              mb: 1,
            }}
          >
            RESPONSE
          </Typography>

          <Box
            sx={{
              p: 1.5,
              borderRadius: 1,
              background: '#131313',
              border: '1px solid #1f2937',
              fontFamily: 'monospace',
              fontSize: 13,
              color: '#d1d5db',
              whiteSpace: 'pre-wrap',
              overflowX: 'auto',
            }}
          >
            {response || 'No response body'}
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
};

export default TestWebhookError;
